import React, { createContext, useEffect, useState } from 'react';
import { usersApi } from 'Feature/Arrears/components/ArrearsInquiryPage/api/UserApi';
import { ArrearsUser } from 'Feature/Arrears/components/ArrearsInquiryPage/core/users/ArrearsUser';
import { useAuthenticationContext } from 'Foundation/Authentication';

export const ArrearsUserContext = createContext(ArrearsUser.defaultValue);

export const ArrearsUserProvider = ({ children }: { children: React.ReactNode }) => {
  const authenticationContext = useAuthenticationContext();
  const [user, setUser] = useState(ArrearsUser.defaultValue);

  useEffect(() => {
    const getUser = async () => {
      const api = usersApi(authenticationContext);
      const result = await api.get();
      if (result.isFailure) {
        throw new Error(`Error loading user: ${result.error}`);
      } else {
        const user = ArrearsUser.fromUserInfo(result.value);
        setUser(user);
      }
    };

    if (authenticationContext.isAuthenticated) {
      getUser();
    }
  }, [authenticationContext]);

  return <ArrearsUserContext.Provider value={user}>{children}</ArrearsUserContext.Provider>;
};
